export default __webpack_public_path__ + "assets/22ea789bca2297ce939c30c26eb18be3.eot";